import React from "react";
import { CDBBtn } from 'cdbreact';

export const ModalArticleTypes = ({ 
  action, 
  formData, 
  setFormData, 
  onSubmit, 
  onCancel,
  setPressedButton 
}) => {

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === 'create' ? 'Crear Tipo de Artículo' : 'Editando Tipo de Artículo'}
          </h3>
        </div>
        {action === 'edit' ? (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => {
              setPressedButton('delete');
            }}
          >
            <i className="fas fa-trash"></i>
            Eliminar Tipo
          </CDBBtn>
        ) : null}
      </div>
      <div className="modal-body">
        {action !== 'create' ? (
          <div className="form-group">
            <label>ID</label>
            <input
              type="text"
              className="form-control mb-4"
              id="id"
              placeholder="ID"
              disabled
              value={formData.id || ''}
            />
          </div>
        ) : null}

        <div className="form-group">
          <label htmlFor="name">Nombre:<span className="text-danger"> *</span></label>
          <input
            type="text"
            className="form-control mb-4"
            id="name"
            placeholder="Nombre del tipo de artículo"
            value={formData.name || ''}
            onChange={handleChange}
            required
          />
        </div>

        <div className="modal-footer justify-content-center align-items-center">
          <CDBBtn
            type="button"
            color="danger"
            outline
            onClick={() => setPressedButton('closeModal')}
          >
            Cerrar
          </CDBBtn>
          <CDBBtn
            type="submit"
            color="success"
            className="mr-auto"
            outline
            onClick={() => setPressedButton('submitModal')}
          >
            Guardar
          </CDBBtn>
        </div>
      </div>
    </div>
  );
};